export enum EdifyContentUnitType {
  Theory = "THEORY",
  Flashcards = "DRILLING",
  Assignment = "ASSIGNMENT",
  TheoryAssignment = "THEORYASSIGNMENT",
}
